<template>
  <div class="ensemble">
    <!-- 图片区域 -->
    <div :style="{ 'height': imgHeight + 'vh', 'width': imgWidth + 'vh' }">
      <img :src="picImg" alt="设置照片地址" class="picImgStyle" />
    </div>
    <!-- 文字区域 -->
    <div class="textFrame" :style="{ 'width': imgWidth + 'vh', backgroundColor: textBackground }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    imgHeight: {
      type: String,
      default: "auto"
    },
    imgWidth: {
      type: String,
      default: "auto"
    },
    // 照片地址
    picImg: {
      type: String,
      default: require('../assets/bg3.png')
    },
    // 文字背景颜色
    textBackground: {
      type: String,
    }
  }
}
</script>

<style lang="scss" scoped>
.ensemble {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

// 文字
.textFrame {
  border-radius: 0 0 15px 15px;
  background-color: rgb(255, 255, 255);
  flex: 1;

  &:hover {
    background-color: rgb(132, 0, 0);
    color: rgb(255, 255, 255);
  }
}


// 图片伪类选择器
img:hover {
  transform: scale(1.02);
}

// 照片样式
.picImgStyle {
  border-radius: 15px 15px 0 0;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/imgAndText.vue